export class ShopOrder {
	order_id: number;
	order_status: string;
	order_sum_incl: string;
	order_sum_excl: string;
	order_sub_sum_incl: string;
	order_sub_sum_excl: string;
	order_invoice_number: string;
	crm_offer_id: number;
}



// WEBPACK FOOTER //
// /var/www/vhosts/s-wines.nl/httpdocs/crm/resources/assets/src/app/shared/models/shop/shop_order.ts